import { useTranslations } from '@npco/common-utils-translations'
import {
  ButtonFill,
  ButtonLink,
  Flex,
  Tutorial,
} from '@npco/zeller-design-system'
import { ImageContainer } from 'features/StartupModals/SetupFlow/components/ImageContainer/ImageContainer'
import * as styled from 'features/StartupModals/StartupModals.styled'

import CorporateCardStartupLarge from 'assets/images/corporate-card/corporate-card-startup-large.png'
import CorporateCardStartupMedium from 'assets/images/corporate-card/corporate-card-startup-medium.png'
import CorporateCardStartupSmall from 'assets/images/corporate-card/corporate-card-startup-small.png'
import { translationsShared } from 'translations/index'

import { corporateCardStartupTranslations } from '../../CorporateCardStartup.i18n'
import { CorporateCardStartupModalMainContent } from '../CoporateCardStartupModalMainContent/CorporateCardStartupModalMainContent'
import { useCorporateCardStartupModal } from './hooks/useCorporateCardStartupModal'

export const CorporateCardStartupModal = () => {
  const t = useTranslations(corporateCardStartupTranslations)
  const tShared = useTranslations(translationsShared)
  const { isOpen, handleClose, handleCreateCard } =
    useCorporateCardStartupModal()

  return (
    <styled.CustomizedModal
      className="animated-content"
      closeTimeoutMS={350}
      isOpen={isOpen}
      onCancel={handleClose}
      overlayClassName="animated-overlay"
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
    >
      <Tutorial.TutorialLayout
        Footer={
          <Flex
            justifyContent="space-between"
            padding={{
              _: '12px 24px 24px',
              SM: '12px 32px 32px',
              LG: '12px 0 0 0',
            }}
            width="100%"
          >
            <ButtonLink onClick={handleClose}>{tShared('close')}</ButtonLink>
            <ButtonFill onClick={handleCreateCard}>
              {t('primaryButtonLabel')}
            </ButtonFill>
          </Flex>
        }
        Illustration={
          <ImageContainer
            mobileImagePath={CorporateCardStartupSmall}
            tabletImagePath={CorporateCardStartupMedium}
            desktopImagePath={CorporateCardStartupLarge}
          />
        }
        MainContent={<CorporateCardStartupModalMainContent />}
      />
    </styled.CustomizedModal>
  )
}
